import React from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-teal-950 via-teal-900 to-stone-900">
      {/* Decorative circles */}
      <div className="absolute top-1/4 right-0 w-96 h-96 rounded-full bg-teal-700/20 blur-3xl" />
      <div className="absolute bottom-0 left-1/4 w-64 h-64 rounded-full bg-teal-500/10 blur-2xl" />

      <div className="relative max-w-6xl mx-auto px-6 pt-24 pb-20">
        <p className="text-teal-400 text-xs uppercase tracking-[0.3em] mb-6">Psicología Clínica</p>
        <h1 className="font-display text-5xl md:text-7xl text-white leading-[1.05] mb-6 max-w-3xl">
          Un lugar donde<br />
          <em className="text-teal-300 not-italic">sanar es posible</em>
        </h1>
        <p className="text-teal-100/70 text-lg leading-relaxed max-w-lg mb-10">
          Ofrecemos acompañamiento psicológico especializado para adultos que han vivido experiencias de trauma, ansiedad y duelo.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link to="/contacto" className="btn-primary">Agendar primera consulta</Link>
          <Link to="/servicios" className="btn-outline border-teal-400 text-teal-300 hover:bg-teal-700 hover:text-white hover:border-teal-700">
            Ver servicios
          </Link>
        </div>
      </div>
    </section>
  );
}